import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MoreHorizontal } from 'lucide-react';
import { navLinks } from './NavLinks';
import BottomSheet from './BottomSheet';

const BottomNav: React.FC = () => {
  const location = useLocation();
  const [isSheetOpen, setSheetOpen] = useState(false);

  // On affiche seulement les 3 premiers liens directement
  const mainLinks = navLinks.slice(0, 3);

  return (
    <>
      <nav className="lg:hidden fixed bottom-4 left-4 right-4 z-40 bg-white/80 backdrop-blur-md border border-white/30 rounded-2xl shadow-xl shadow-gray-400/20">
        <div className="flex justify-around items-center h-14 px-2">
          {mainLinks.map((link) => {
            const isActive = location.pathname === link.to;
            return (
              <NavLink
                key={link.id}
                to={link.to}
                className={`flex flex-col items-center justify-center gap-0.5 px-2 py-1 rounded-lg transition-all duration-200 ${
                  isActive ? 'text-accent' : 'text-black hover:text-gray-700'
                }`}
              >
                <link.icon
                  className={`w-5 h-5 stroke-[2] transition-transform duration-200 ${
                    isActive ? 'stroke-accent' : 'stroke-black'
                  }`}
                />
                <span className="text-[9px] font-bold uppercase tracking-wider">
                  {link.label}
                </span>
              </NavLink>
            );
          })}

          {/* Bouton Plus */}
          <button
            onClick={() => setSheetOpen(true)}
            className="flex flex-col items-center justify-center gap-0.5 px-2 py-1 rounded-lg transition-all duration-200 text-black hover:text-gray-700"
          >
            <MoreHorizontal className="w-5 h-5 stroke-[2]" />
            <span className="text-[9px] font-bold uppercase tracking-wider">Plus</span>
          </button>
        </div>
      </nav>

      {/* Bottom Sheet */}
      <BottomSheet isOpen={isSheetOpen} onClose={() => setSheetOpen(false)} />
    </>
  );
};

export default BottomNav;